//image imports:
import logo from '@src/assets/logo.svg';

//style imports:
import '@src/scss/components/Splash.scss';

const Splash = () => {

    return (
    <div className="splash-page">
        <img src={logo} alt="logo"/>
    </div>
    )
}

export {Splash};